import { render, staticRenderFns } from "./TableCell.vue?vue&type=template&id=37cab202&scoped=true"
import script from "./TableCell.vue?vue&type=script&lang=js"
export * from "./TableCell.vue?vue&type=script&lang=js"
import style0 from "./TableCell.vue?vue&type=style&index=0&id=37cab202&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cab202",
  null
  
)

export default component.exports